// extracted by mini-css-extract-plugin
export default {"root":"NavOverlay_root__8NNt8","expanded":"NavOverlay_expanded__TbrbI"};